jQuery(document).ready(function ($) {
    /* ==================== Fonts ==================== */
    const WebFont = require("webfontloader");
    const fontMeta = document.getElementById("font_values");
    if (fontMeta) {
        const headingFont = fontMeta.dataset.headingFont;
        const bodyFont = fontMeta.dataset.bodyFont;
        if (!bodyFont || !headingFont) {
            WebFont.load({
                google: {
                    families: ["Montserrat:300,400,500,600,700,900"],
                },
            });
        }
    }
    /* ==================== Menus ==================== */
    const mobileMenuToggle = document.querySelector(".navToggle"), mobileMenu = document.getElementById("mobileNav"), header = document.querySelector("#header"), stickyHeader = document.querySelector("#header.is-sticky:not(.transparent)"), stickyTransaprentHeader = document.querySelector("#header.is-sticky.transparent"), subMenuItems = document.querySelectorAll(".menu-item-has-children"), mobileSubMenuItems = document.querySelectorAll("#mobileNav .menu-item-has-children"), adminBar = document.getElementById("wpadminbar"), contentWrap = document.querySelector(".page-content-wrap");
    // Create drawer style submenus if option selected
    if (mobileMenu.classList.contains("drawer")) {
        const subMenus = document.querySelectorAll("#mobileNav .menu-wrap > nav > ul > .menu-item-has-children");
        for (let i = 0; i < subMenus.length; i++) {
            let subMenuHeader = document.createElement("div"), subMenuParent = subMenus[i].querySelector(".sub-menu-wrap"), subMenuNode = subMenuParent.querySelector(".container");
            subMenuHeader.classList.add("container", "submenu-header");
            subMenuHeader.innerHTML = `
        <button class="back"><i class="fa-solid fa-arrow-left"></i>Go Back</button>
        <p>${subMenus[i].querySelector("a").innerText}</p>
      `;
            subMenuParent.insertBefore(subMenuHeader, subMenuNode);
        }
    }
    mobileSubMenuItems.forEach((element) => {
        element.addEventListener("click", toggleSubMenu);
    });
    function toggleSubMenu() {
        this.classList.toggle("active");
    }
    let headerOffset;
    const setHeaderHeight = (context) => {
        let transparentHeader = document.querySelector("header.transparent");
        headerOffset = header.offsetHeight;
        let adminBarHeight = 0;
        if (adminBar) {
            adminBarHeight = adminBar.offsetHeight;
        }
        else {
            adminBarHeight = 0;
        }
        if (headerOffset && adminBarHeight !== 0) {
            let totalHeight;
            if (context === "scrolling" && window.scrollY > 40) {
                totalHeight = headerOffset;
            }
            else {
                totalHeight = headerOffset + adminBarHeight;
            }
            mobileMenu.style.minHeight = `calc(100vh - ${totalHeight}px)`;
            mobileMenu.style.top = `${totalHeight}px`;
            if (stickyHeader) {
                header.style.top = `${adminBarHeight}px`;
            }
        }
        else {
            mobileMenu.style.minHeight = `calc(100vh - ${headerOffset}px)`;
            mobileMenu.style.top = `${headerOffset}px`;
        }
        if (transparentHeader) {
            transparentHeader.style.marginBottom = `-${headerOffset}px`;
        }
        if (stickyTransaprentHeader) {
            header.style.top = `${adminBarHeight}px`;
        }
        // Move content down for sticky header
        if (stickyHeader) {
            if (adminBarHeight !== null) {
                contentWrap.style.marginTop = `${headerOffset - adminBarHeight}px`;
            }
            else {
                contentWrap.style.marginTop = `${headerOffset}px`;
            }
        }
    };
    // Initialize header and mobile menu height
    setTimeout(() => {
        setHeaderHeight(null);
    }, 100);
    // Listen for window resizing to update header and mobile menu height as screen size changes
    addEventListener("resize", () => {
        setHeaderHeight("resize");
    });
    addEventListener("scroll", () => {
        setTimeout(() => {
            setHeaderHeight("scrolling");
        }, 100);
    });
    mobileMenuToggle.addEventListener("click", () => {
        mobileMenuToggle.classList.toggle("is-active");
        mobileMenu.classList.toggle("menu-open");
        if (mobileMenu.classList.contains("drawer")) {
            header.classList.toggle("mobile-menu-open");
        }
    });
});
/* ==================== Scrolling Classes ==================== */
let scrollYPos = 0;
const header = document.querySelector("#header"), stickyHeader = document.querySelector("#header.is-sticky");
addEventListener("scroll", () => {
    if (stickyHeader) {
        stickyHeader.classList.toggle("sticky-header", window.scrollY > 40);
    }
    header.classList.toggle("scroll-up", window.scrollY < scrollYPos);
    header.classList.toggle("scroll-down", window.scrollY > scrollYPos);
    scrollYPos = window.scrollY;
});
